<template>
    <div>
        <LineChart :chart-data="chartData" :chart-options="chartOptions" />
    </div>
</template>

<script>
import LineChart from './LineChart.vue';

function sum(...items) {
    if (!items.length) return 0;
    return items.reduce((r, x) => { r += x; return r; });
}

export default {
    name: 'App',
    components: {
        LineChart,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        labels: {
            type: Object,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: 'top',
                    },
                    title: {
                        display: true,
                        // text: this.title,
                    },
                },
                scales: {
                    x: {
                        grid: {
                            display: false, // 隐藏 X 轴网格线
                        },
                        title: {
                            display: true,
                            text: '',
                        },
                    },
                    y: {
                        grid: {
                            display: false, // 隐藏 Y 轴网格线
                        },
                        title: {
                            display: true,
                            text: '负荷率（%)',
                        },
                    },
                },
            };
        },
        chartData() {
            const data = this.data ?? [];
            const size = data.length;
            const avg = parseInt(sum(...data) / size);
            const average_data = new Array(size).fill(avg);
            const limit_value = parseInt(sum(...data.map(x => Math.abs(x - avg))) / size);
            const upper_data = new Array(size).fill(avg + limit_value);
            const lower_data = new Array(size).fill(avg - limit_value);
            const labels = this.labels.map(x => x.substr(5, 5).replace('-', '/'));
            return {
                labels,
                datasets: [
                    {
                        label: '负荷率',
                        borderColor: '#42A5F5',
                        backgroundColor: 'rgba(66, 165, 245, 0.2)',
                        data,
                        fill: false,
                    },
                    {
                        label: '平均',
                        data: average_data,
                        borderColor: 'rgba(200, 200, 200, 0.8)', // 浅灰色
                        borderWidth: 2,
                        borderDash: [5, 5], // 虚线样式
                        pointRadius: 0,
                        fill: false,
                    },
                    {
                        label: '下限',
                        data: lower_data,
                        borderColor: 'rgba(200, 200, 200, 0.8)', // 浅灰色
                        borderWidth: 2,
                        borderDash: [5, 5], // 虚线样式
                        pointRadius: 0,
                        fill: false,
                    },
                    {
                        label: '上限',
                        data: upper_data,
                        borderColor: 'rgba(200, 200, 200, 0.8)', // 浅灰色
                        borderWidth: 2,
                        borderDash: [5, 5], // 虚线样式
                        pointRadius: 0,
                        fill: false,
                    },
                ],
            };
        },
    },
};
</script>
